export type Rectangle = {
  readonly width: number
  readonly height: number
}
